import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as LinkIcon } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface DrbfmTraceAlertProps {
  sourceDrbfmSessionId: string;
}

const DrbfmTraceAlert: React.FC<DrbfmTraceAlertProps> = ({ sourceDrbfmSessionId }) => {
  const { t } = useTranslation();

  return (
    <Alert variant="info" className="mt-4">
      <LinkIcon className="size-4" strokeWidth={1.9} />
      <div className="flex flex-wrap items-center justify-between gap-2">
        <AlertDescription className="revy-cjk text-sm leading-[1.6]">
          {t('verification.drbfmLink', 'この項目はDRBFM分析から生成されました')}
        </AlertDescription>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => window.open(`/drbfm?session=${sourceDrbfmSessionId}`, '_blank')}
        >
          <span className="revy-cjk">
            {t('verification.drbfmLinkTooltip', 'DRBFM分析結果を表示')}
          </span>
        </Button>
      </div>
    </Alert>
  );
};

export default DrbfmTraceAlert;
